/**
 * Configuration file template
 */

export function getConfigTemplate(): string {
  return `/**
 * Vibeship DevTools Configuration
 * Generated by: npx vibeship init
 */

import { defineConfig } from '@vibeship/devtools/config';

export default defineConfig({
  // Paths to scan for tasks
  scanPaths: ['./src', './app', './pages', './components', './docs', './README.md'],
  
  // File patterns to include
  include: ['**/*.ts', '**/*.tsx', '**/*.js', '**/*.jsx', '**/*.md', '**/*.mdx'],
  
  // Patterns to exclude
  exclude: ['**/node_modules/**', '**/.next/**', '**/dist/**', '**/build/**'],
  
  // Feature flags
  features: {
    tasks: true,
    ai: true,
    realtime: true,
    commandPalette: true,
    fileEditing: true,
    markdownPreview: true,
  },
  
  // Task patterns to search for
  taskPatterns: {
    todo: true,
    fixme: true,
    hack: true,
    note: true,
    bug: true,
    optimize: true,
    refactor: true,
  },
  
  // UI configuration
  ui: {
    theme: 'system', // 'light', 'dark', or 'system'
    position: 'bottom-right',
    defaultSize: {
      width: '400px',
      height: '600px',
    },
    hotkey: 'ctrl+shift+d',
    showInProduction: false,
  },
  
  // API configuration
  api: {
    basePath: '/api/vibeship',
    timeout: 30000,
  },
  
  // Security settings
  security: {
    // File write permissions
    allowFileWrites: process.env.NODE_ENV === 'development',
    
    // Allowed paths for file operations
    allowedPaths: ['./src', './app', './pages', './components', './docs'],
    
    // Blocked patterns
    blockedPatterns: [
      '**/.env*',
      '**/*.key',
      '**/*.pem',
      '**/secrets/**',
      '**/credentials/**',
    ],
  },
  
  // Cache configuration
  cache: {
    enabled: true,
    directory: '.vibeship/cache',
    maxSize: 52428800, // 50MB
    ttl: 3600000, // 1 hour
  },
});
`;
}